import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  jump(event) {
    const selected = event.target.value
    if (!selected) return

    const element = document.querySelector(selected)
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
    }
  }
}
